import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-neutral-600 font-medium text-sm text-left" }
const _hoisted_2 = { class: "mt-6" }
const _hoisted_3 = { class: "mt-6 text-center flex space-x-2 justify-center" }

import {
  DialogTitle,
} from '@headlessui/vue';
import BaseModal from '@/components/modals/BaseModal.vue';
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResolutionModal',
  props: {
    show: {
        type: Boolean
    },
    title: {
        type: String,
    },
    description: {
        type: String,
    },
    cancelText: {
        type: String,
    },
    actionText: {
        type: String,
    },
    customClass: {
        type: String,
        default: 'w-[660px] py-6 px-11 min-w-[480px] max-h-[80vh]'
    },
    isNetworkAvailable: {
        type: Boolean,
        default: false,
    }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    customClass: __props.customClass,
    show: __props.show
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogTitle), {
        as: "p",
        class: "text-xl font-bold mb-1 text-left"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.title), 1)
        ]),
        _: 1
      }),
      _createElementVNode("p", _hoisted_1, _toDisplayString(__props.description), 1),
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "content")
      ]),
      _createElementVNode("div", _hoisted_3, [
        (__props.cancelText)
          ? (_openBlock(), _createBlock(ButtonComponent, {
              key: 0,
              size: "large",
              btnWidth: "quinary rounded-lg",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.cancelText), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (__props.actionText && __props.isNetworkAvailable)
          ? (_openBlock(), _createBlock(ButtonComponent, {
              key: 1,
              size: "large",
              btnWidth: "primary rounded-lg",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.actionText), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 3
  }, 8, ["customClass", "show"]))
}
}

})